import React from "react";
import { fetchData, URL_SHIP_AGGREGATED_OBSERVATIONS_POPUP } from "../../../utils/api";
import LinkOSCAR from "../LinkOSCAR/LinkOSCAR";
import LinkMarineRoute from "../LinkMarineRoute/LinkMarineRoute";
import {
  getLabelID,
  groupCenterValues,
  renderGroupedCenters,
  renderCenterValues,
  processQualityMetrics
} from "./popupUtils";

export function fetchShipPopupInfo(
  props,
  periodsAsQP,
  linkTimeSeries,
  setContent,
  multiplier
) {
  fetchData(
    `${URL_SHIP_AGGREGATED_OBSERVATIONS_POPUP}/?baseline=${props.baseline}&period_type=${props.selectedPeriodType}&report=${props.selectedReport}&station_id=${props.stationObject.station_id}&${periodsAsQP}&var_id=${props.selectedVariable}`
  ).then(response => {
    if (response.data.length > 0) {
      let labelID = getLabelID(response.data[0], response.data[0].in_oscar);
      props.onSetSelectedStation({
        name: response.data[0].station,
        wigosid: response.data[0].wigosid,
        in_oscar: response.data[0].in_oscar
      });

      const part1 = [
        `Name: ${response.data[0].station}`,
        `${labelID}: ${response.data[0].wigosid}`
      ];

      let centers = [];
      let centersValues = [];
      if (props.selectedReport === "availability") {
        const availCenters = response.data.map(d => d.center);
        if (props.combinedMode) {
          const allStandardCenters = ["DWD", "ECMWF", "JMA", "NCEP"];
          let maxNrExpected = 0;
          allStandardCenters.forEach(center => {
            const idx = availCenters.indexOf(center);
            const nr_received = idx !== -1 ? response.data[idx].nr_received : "No data";
            if (idx !== -1 && response.data[idx].nr_expected !== null &&
                response.data[idx].nr_expected > maxNrExpected) {
              maxNrExpected = response.data[idx].nr_expected;
            }
            centersValues.push({ type: "value", value: `#${center}: ${nr_received}` });
          });
          centersValues.push({ type: "value", value: `#Expected: ${maxNrExpected}` });
        } else {
          const idx = availCenters.indexOf(props.selectedCenter);
          const nr_received = idx !== -1 ? response.data[idx].nr_received : "No data";
          const nr_expected = idx !== -1 ? response.data[idx].nr_expected : 0;
          centersValues.push({ type: "value", value: `#Received: ${nr_received}` });
          centersValues.push({ type: "value", value: `#Expected: ${nr_expected}` });
        }
      } else {
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];

          if (props.combinedMode) {
            if (!centers.includes(element.center)) {
              centers.push(element.center);
              centersValues.push({
                type: "title",
                value: element.center
              });
            }
          }
          if (
            props.selectedPeriodType === "monthly" &&
            props.selectedReport === "quality"
          ) {
            let centersList = ["DWD", "ECMWF", "JMA", "NCEP"];
            if (centersList.includes(element.center)) {
              const metrics = processQualityMetrics(
                element,
                props.selectedVariable,
                props,
                multiplier
              );

              if (!props.combinedMode) {
                centersValues.push({
                  type: "value",
                  value: `Avg(O-B): ${metrics.avg_bg_dep}`,
                  highlight: false
                });

                centersValues.push({
                  type: "value",
                  value: `STD(O-B): ${metrics.std_bg_dep}`,
                  highlight: false
                });
              }

              centersValues.push({
                type: "value",
                value: `RMSE: ${metrics.rms}`,
                highlight: metrics.toHighlight
              });

              if (props.combinedMode) {
                centersValues.push({
                  type: "value",
                  value: `GE%: ${metrics.gross_error_percent}`,
                  highlight: false
                });
              }
            }
          } else {
            const toHighligth =
              Math.round(Math.abs(element.avg_bg_dep) * 100000) / 100000 ===
              Math.round(Math.abs(props.stationObject.avg_bg_dep) * 100000) /
                100000;
            let avg_bg_value = Math.abs(element.avg_bg_dep);
            if (props.selectedVariable == 58) {
              avg_bg_value = avg_bg_value * 100;
            }
            avg_bg_value = avg_bg_value.toFixed(2);

            centersValues.push({
              type: "value",
              value: `Value: ${avg_bg_value}`,
              highlight: toHighligth
            });
          }
        }
      }
      const htmlPart1 = part1.map(v => {
        return <li key={v}>{v}</li>;
      });

      let htmlPart2;
      if (props.combinedMode && props.selectedReport !== "availability") {
        const groupedCenters = groupCenterValues(centersValues);
        htmlPart2 = renderGroupedCenters(groupedCenters);
      } else {
        htmlPart2 = renderCenterValues(centersValues);
      }

      const htmlContent = (
        <>
          <span>
            <b>SHIP</b>
          </span>
          {htmlPart1}
          {htmlPart2}
        </>
      );

      let linkOSCAR;

      let links = linkTimeSeries;
      let linkMarineRoute = (
        <>
          <LinkMarineRoute
            file_type="ship"
            period_type={props.selectedPeriodType}
            report={props.selectedReport}
            station_id={props.stationObject.station_id}
            periodsAsQP={periodsAsQP}
            var_id={props.selectedVariable}
            wigosid={response.data[0].wigosid}
            selectedSixHPeriod={props.selectedSixHPeriod}
            selectedDate={props.selectedDate}
            centers={props.periodData[props.selectedPeriodType].centers}
            selectedCenter={props.selectedCenter}
          />
        </>
      );

      linkOSCAR = (
        <>
          <LinkOSCAR wigosid={response.data[0].wigosid} />
        </>
      );
      if (!response.data[0].in_oscar) {
        linkOSCAR = (
          <a
            className="isDisabled link-oscar"
            target="_blank"
            rel="noopener noreferrer"
            href="#"
            onClick={e => e.preventDefault()}
          >
            Open in OSCAR
          </a>
        );
      }
      links = (
        <>
          {linkTimeSeries}
          <br />
          {linkMarineRoute}
          <br />
          <hr />
          {linkOSCAR}
        </>
      );

      setContent(
        <ul className="popup-station-properties">
          {htmlContent}
          {links}
        </ul>
      );
    }
  });
}
